import 'css-chunk:../../frontend/phi3d/src/js/components/Modals/ColorsMaterials.module.scss';export default {
  "wrapper": "_wrapper_n019k_1",
  "button": "_button_n019k_10",
  "image": "_image_n019k_22"
};